module.exports = __webpack_public_path__ + "static/images/containers/ClanManagement/components/MembersControlBlock/images/change_role.e41c1d91.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanManagement/components/MembersControlBlock/images/change_role.png
// module id = 3056
// module chunks = 11